import React, { useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
// eslint-disable-next-line
import { Toast } from "primereact/toast";
import UserFormPreviewDialog from "./UserFormPreviewDialog";
import UserFilledFormsDialog from "../UserFilledForms/UserFilledFormsDialog";

const UserFormsListDatatableComponent = ({
  data,
  filters,
  setFilters,
  header,
  loading,
  first,
  rows,
  totalRecords,
  onPageChange,
  handleStatusChange,
  onSort,
  sortField,
  sortOrder,
}) => {
  const [selectedForm, setSelectedForm] = useState(null);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [filledFormsDialogVisible, setFilledFormsDialogVisible] =
    useState(false);
  const [selectedFormForFilledForms, setSelectedFormForFilledForms] =
    useState(null);
  const toast = useRef(null);

  const viewForm = (rowData) => {
    setSelectedForm(rowData);
    setDialogVisible(true);
  };

  const viewFilledForms = (rowData) => {
    setSelectedFormForFilledForms(rowData);
    setFilledFormsDialogVisible(true);
  };

  const handleStatusChangeWrapper = async (rowData, value) => {
    const newStatus = value ? "up" : "down";
    try {
      await handleStatusChange(rowData.id, rowData.status, rowData.title);
      rowData.status = newStatus;
    } catch (error) {
      console.error("Failed to update form status:", error);
    }
  };

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(date);
  };

  return (
    <div className="table-container">
      <Toast ref={toast} />
      {loading ? (
        <div className="loader-container">
          <ProgressSpinner />
        </div>
      ) : (
        <>
          <DataTable
            style={{ fontFamily: "poppins" }}
            value={data}
            paginator={false}
            responsiveLayout="scroll"
            filters={filters}
            globalFilterFields={["id", "title", "createdAt"]}
            header={header}
            emptyMessage="No forms found."
            onFilter={(e) => setFilters(e.filters)}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
          >
            <Column
              field="title"
              header="Title"
              style={{ width: "40%" }}
              sortable
            ></Column>
            <Column
              field="createdAt"
              header="Created"
              body={(rowData) => formatDate(rowData.createdAt)}
              style={{ width: "25%" }}
              sortable
            ></Column>
            <Column
              field="status"
              header="Status"
              body={(rowData) => (
                <InputSwitch
                  checked={rowData.status === "up"}
                  onChange={(e) => handleStatusChangeWrapper(rowData, e.value)}
                  disabled
                />
              )}
              style={{ width: "15%" }}
              sortable
            ></Column>
            <Column
              header="Actions"
              body={(rowData) => (
                <div className="actions">
                  <Button
                    icon="pi pi-eye"
                    className="p-button p-button-info mr-2"
                    style={{
                      backgroundColor: "#fff",
                      color: "#0d2e4d",
                      border: "none",
                      transition: "border 0.3s ease",
                    }}
                    onClick={() => viewForm(rowData)}
                    tooltip="View Form Schema"
                    tooltipOptions={{ position: "top" }}
                  />
                  <Button
                    icon="pi pi-briefcase"
                    className="p-button p-button-info mr-2"
                    style={{
                      backgroundColor: "#fff",
                      color: "#d97a07",
                      border: "none",
                      transition: "border 0.3s ease",
                    }}
                    onClick={() => viewFilledForms(rowData)}
                    tooltip="View Filled Forms"
                    tooltipOptions={{ position: "top" }}
                  />
                  <Button
                    icon="pi pi-external-link"
                    className="p-button p-button-success"
                    style={{
                      backgroundColor: "#fff",
                      color: "#0d2e4d",
                      border: "none",
                      transition: "border 0.3s ease",
                    }}
                    onClick={() =>
                      window.open(`/User-Fill-Form/${rowData.id}`, "_blank")
                    }
                    tooltip="Open Form"
                    tooltipOptions={{ position: "top" }}
                  />
                </div>
              )}
              style={{ width: "20%" }}
            ></Column>
          </DataTable>
          <Paginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
          ></Paginator>
        </>
      )}
      <UserFormPreviewDialog
        visible={dialogVisible}
        onHide={() => setDialogVisible(false)}
        form={selectedForm}
      />

      {selectedFormForFilledForms && (
        <UserFilledFormsDialog
          visible={filledFormsDialogVisible}
          onHide={() => setFilledFormsDialogVisible(false)}
          formId={selectedFormForFilledForms.id}
          formTitle={selectedFormForFilledForms.title}
        />
      )}
    </div>
  );
};

export default UserFormsListDatatableComponent;
